import type {BadgesInProgressCollectionSectionContentModel} from './badgesInProgressCollectionSectionContentModel';
import type {BadgesInProgressSectionContentModel} from './badgesInProgressSectionContentModel';
import type {HeaderSectionContentModel} from './headerSectionContentModel';

export type {BadgesInProgressCollectionSectionContentModel} from './badgesInProgressCollectionSectionContentModel';
export type {BadgesInProgressSectionContentModel} from './badgesInProgressSectionContentModel';
export type {HeaderSectionContentModel} from './headerSectionContentModel';

export const DYNAMIC_PAGE_SECTION_TYPES = {
    HEADER: 'HEADER_SECTION',
    BADGES_IN_PROGRESS: 'BADGES_IN_PROGRESS_SECTION',
    BADGES_COLLECTION: 'BADGES_COLLECTION_SECTION',
    BADGES_IN_PROGRESS_COLLECTION: 'BADGES_IN_PROGRESS_COLLECTION_SECTION',
} as const;

export type DynamicPageSectionType = (typeof DYNAMIC_PAGE_SECTION_TYPES)[keyof typeof DYNAMIC_PAGE_SECTION_TYPES];

interface DynamicPageSectionBase {
    id?: string;
    order?: number;
}

interface DynamicPageSectionContentByType {
    [DYNAMIC_PAGE_SECTION_TYPES.HEADER]: HeaderSectionContentModel | null;
    [DYNAMIC_PAGE_SECTION_TYPES.BADGES_IN_PROGRESS]: BadgesInProgressSectionContentModel | null;
    [DYNAMIC_PAGE_SECTION_TYPES.BADGES_COLLECTION]: null;
    [DYNAMIC_PAGE_SECTION_TYPES.BADGES_IN_PROGRESS_COLLECTION]: BadgesInProgressCollectionSectionContentModel | null;
}

type DynamicPageSectionModelByType = {
    [SectionType in keyof DynamicPageSectionContentByType]: DynamicPageSectionBase & {
        type: SectionType;
        content?: DynamicPageSectionContentByType[SectionType];
    };
};

export type DynamicPageSectionModel = DynamicPageSectionModelByType[keyof DynamicPageSectionModelByType];

export interface DynamicPageModel {
    id?: string;
    title?: string | null;
    pageSections?: DynamicPageSectionModel[];
}

export interface DynamicPagesContentModel {
    dynamicPages?: DynamicPageModel[];
}
